import React, { FC } from "react";
import Card12 from "./Card12";
import Card13 from "./Card13";

export interface SectionMagazine5Props {
  blog: any[];
}

const SectionMagazine5: FC<SectionMagazine5Props> = ({ blog }) => {
  const chunkedSections = [];

  for (let i = 0; i < blog.length; i += 5) {
    const card12 = blog[i];
    const card13Group = blog.slice(i + 1, i + 5);

    chunkedSections.push({ card12, card13Group });
  }
  return (
    <div className="nc-SectionMagazine5">
      {chunkedSections.map((section, idx) => (
        <div
          key={idx}
          className={`grid gap-6 md:gap-8 mt-10 ${blog?.length === 1 ? 'grid-cols-1' : 'lg:grid-cols-2'
            }`}
        >
          {section.card12 && <Card12 post={section.card12} />}
          <div className="grid gap-6 md:gap-8">
            {section.card13Group.map((item, index) => (
              <Card13 key={index} post={item} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SectionMagazine5;
